import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'

const ClientsTable = ({
    clients
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Name',
                accessorKey: 'name'
            },
            {
                header: 'Email Address',
                accessorKey: 'email'
            },
            {
                header: 'Username',
                accessorKey: 'username'
            },
            {
                header: 'Phone Number',
                accessorKey: 'phone'
            },
            {
                header: 'Contact Person',
                accessorKey: 'contact_person'
            },
            {
                header: 'City',
                accessorKey: 'city.name'
            }
        ],
        []
    );

    const table = useReactTable({
        data: clients,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (clients.length === 0){
        return <div className="text-center">No clients found</div>
    }
  return (
    <table className='table table-striped table-hover'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                        <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
                    ))}
                </tr>
            ))}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default ClientsTable